import * as yup from 'yup';

export const incomeNetWorthMapping = {
        1: { minNetWorth: 100000, maxNetWorth: 1000000, errorMessage:"Net Worth Should Be Between 1-10 Lakh" , suggestionText:"Please Enter Value Between 1-10 Lakh"}, // 1-10 Lac
        2: { minNetWorth: 1000000, maxNetWorth: 5000000, errorMessage: "Net Worth Should Be Between 10-50 Lakh", suggestionText:"Please Enter Value Between 10-50 Lakh"}, // 10-50 Lacs
        3: { minNetWorth: 5000000, maxNetWorth: 10000000, errorMessage: "Net Worth Should Be Between 50 Lakh-1 Crore", suggestionText:"Please Enter Value Between 50 Lakh-1 Crore"}, // 50 Lacs-1 Crore
        4: { minNetWorth: 10000000, maxNetWorth: 25000000, errorMessage: "Net Worth Should Be Between 1-2.5 Crore", suggestionText:"Please Enter Value Between 1-2.5 Crore"}, // 1-2.5 Crore
        5: { minNetWorth: 25000000, maxNetWorth: 500000000, errorMessage: "Net Worth Should Be Between 2.5-50 Crore", suggestionText:"Please Enter Value Between 2.5-50 Crore"}, // 2.5 - 50 Crore
    };

const editSchema = yup.object({
  
  networth: yup
    .number()
    .required("Net Worth is required")
    .test('is-valid-net-worth', function (value) {
      const { anualIncomeRange } = this.parent;
      const incomeRange = incomeNetWorthMapping[anualIncomeRange];

      if (!incomeRange) return true;

      const minNetWorth = incomeRange.minNetWorth;
      const maxNetWorth = incomeRange.maxNetWorth;

      const isValid = value >= minNetWorth && value <= maxNetWorth;
      return isValid || this.createError({ message: incomeRange.errorMessage });
  }),
  networthDate: yup
    .number()
    .required("Net Worth As On Date is Required"),
});

const nonEditSchema = yup.object({
  fatherOrSpouse: yup
    .string('')
    .required('Relation is required'),
  firstName: yup
    .string('First Name is required')
    .matches(/^[A-Za-z.']+( [A-Za-z'.]+)*$/, "Enter a valid First Name")
    .required('First Name is required'),
  pan: yup
    .string('PAN Number is required')
    .matches(/[A-Za-z]{3}[pP]{1}[A-Za-z]{1}\d{4}[A-Za-z]{1}/, "Enter valid PAN Number")
    .required('PAN Number is required'),
  middleName: yup
    .string('Middle Name is required')
    .matches(/^[A-Za-z.']+( [A-Za-z'.]+)*$/, "Enter a valid Middle Name"),
    // .required(localeText?.middleNameAsperPanRequired),
  lastName: yup
    .string('Last Name is required')
    .matches(/^[A-Za-z.']+( [A-Za-z'.]+)*$/, "Enter a valid Last Name"),
    // .required("Last Name is required"),
  fathersSpouseFirstName: yup
    .string('')
    .matches(/^[a-zA-Z.']*$/, "Enter valid name")
    .required('Relation First Name is required'),
  fathersSpouseMiddleName: yup
    .string('')
    .matches(/^[a-zA-Z.']*$/, "Enter valid name"),
  fathersSpouseLastName: yup
    .string('')
    .matches(/^[a-zA-Z.']*$/, "Enter valid name"),
    // .required('Relation Last Name is required'),
  maritialStatus: yup
    .string('')
    .nullable()
    .required('Marital Status is required'),
  mothersFirstName: yup
    .string('')
    .matches(/^[a-zA-Z.']*$/, "Enter valid name")
    .required('Mother First Name is required'),
  mothersMiddlename: yup
    .string('')
    .matches(/^[a-zA-Z.']*$/, "Enter valid name"),
  mothersLastName: yup
    .string('')
    .matches(/^[a-zA-Z.']*$/, "Enter valid name"),
    // .required('Mother Last Name is required'),

  anualIncomeRange: yup
    .string('')
    .required('Annual Income Range is required'),
  occupation: yup
    .string('')
    .required('Occupation is required'),
  tradingExp: yup
    .number('')
    .max(99, "Trading experience must be between 0 to 99").min(0, "Trading experience must be between 0 to 99")
    .typeError("Invalid entry"),
  politicalAffiliations: yup
    .string('')
    .required('Political Affiliations is required'),
  natureOfBusiness: yup
    .string('')
    .required('Nature of Business is required'),
  natureOfBusinessOther: yup
    .string('')
    .when('natureOfBusiness', {
      is: "5",
      then: yup.string('')
        .required('Other Nature of Business is required'),
      otherwise: yup.string('')
    }),
  sourceOfWealth: yup
    .string('')
    .required('Source of Wealth is required'),
  fatcaDeclaration: yup
    .boolean(''),
  agreementOfConsents: yup
    .boolean(''),
  segment: yup
    .array('')
    .required('Segment selection is required'),
  networth: yup
    .number()
    .required("Net Worth is required")
    .test('is-valid-net-worth', function (value) {
      const { anualIncomeRange } = this.parent;
      const incomeRange = incomeNetWorthMapping[anualIncomeRange];

      if (!incomeRange) return true;

      const minNetWorth = incomeRange.minNetWorth;
      const maxNetWorth = incomeRange.maxNetWorth;

      const isValid = value >= minNetWorth && value <= maxNetWorth;
      return isValid || this.createError({ message: incomeRange.errorMessage });
  }),
  networthDate: yup
    .number()
    .required("Net Worth As On Date is Required"),
});

export const getValidationSchema = (isEdit) => {
  return (
      isEdit ? editSchema : nonEditSchema
    ) 
}